// vendors
import React from 'react';

/* Context, Hooks, Services */
import { ActionPermission } from 'lib/specialPermissions';
import useCurrentUser from 'hooks/useCurrentUser';

/* Utils */
import {
  buildDefaultValues,
  buildGeneralInfoFormFieldsSet,
} from './utils';

// styles
import { Form } from './styles/MemberProfileForm';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

interface GeneralInfoFormProps {
  centerId?: any;
  memberData?: any;
  centers?: Array<{}>;
  handleOnSubmitGeneralInfoForm?: (data: any) => void;
  beforeSendReinvite?: (data: any) => any;
}

const submitButtonProps = {
  children: 'Save',
  color: '#75B753',
  enableOnValidForm: true,
};

const GeneralInfoForm = ({
  memberData,
  centers = [],
  handleOnSubmitGeneralInfoForm,
  beforeSendReinvite,
}: GeneralInfoFormProps) => {
  const { t: translate } = useTranslation();

  const formFieldValidations = Yup.object().shape({
    name: Yup.string()
      .required(translate('validations:FIELD_REQUIRED'))
      .trim()
      .max(50, translate('validations:MAX_LENGTH', { amount: 50 })),
    lastname: Yup.string()
      .required(translate('validations:FIELD_REQUIRED'))
      .trim()
      .min(2, translate('validations:MIN_LENGTH', { amount: 2 }))
      .max(50, translate('validations:MAX_LENGTH', { amount: 50 })),
    role_alias: Yup.string()
      .required(translate('validations:FIELD_REQUIRED'))
      .trim()
      .max(70, translate('validations:MAX_LENGTH', { amount: 70 })),
  });

  const onSubmitForm = (data: any) => {
    const formData = { ...data };
    delete formData.centers;
    formData.type = data?.type?.name;
    formData.center_ids = data?.centers?.map((center: any) => center.id);
    if (handleOnSubmitGeneralInfoForm) return handleOnSubmitGeneralInfoForm(formData);
  };
  const { can, user } = useCurrentUser();

  const handleButton = () => {
    const isUserProfile = user.id === memberData.id.toString();

    if (isUserProfile || can(ActionPermission.EDIT_DIRECTORS)) {
      return submitButtonProps;
    }

    return undefined;
  };

  return (
    <Form
      schema={formFieldValidations}
      onSubmitForm={onSubmitForm}
      submitButtonProps={handleButton()}
      defaultValues={buildDefaultValues(memberData)}
      fieldsSetData={buildGeneralInfoFormFieldsSet({
        memberData,
        translate,
        centers,
        beforeSendReinvite,
      })}
    />
  );
};

export default GeneralInfoForm;
